export enum DeviceType {
  BLUETOOTH_PROXIMITY_SENSOR = "BLUETOOTH_PROXIMITY_SENSOR",
  GPS_TAG = "GPS_TAG",
  NFC_TAG = "NFC_TAG",
  PROXIMITY_TAG = "PROXIMITY_TAG",
  GPS_PROXIMITY_ACCELEROMETER_TAG = "GPS_PROXIMITY_ACCELEROMETER_TAG"
}
